<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="pendingFestivalPrompt" persistent max-width="500px">
      <v-card v-if="currentFestivalPrompt">
        <v-card-title class="text-h5" style="background-color: #005f32; color: white;">
          Festival Holiday Detected
        </v-card-title>
        <v-card-text class="pt-5" style="font-size: 16px;">
          The date <b>{{ formatDate(currentFestivalPrompt.date) }}</b> is a festival holiday <b>({{ currentFestivalPrompt.festival.festivalName }})</b>.
          <br><br>
          Do you want to include it as a Festival leave?
          <br>
          <small>(If Yes, it will be deducted from your Festival Leave. If No, it will remain as Casual Leave).</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="rejectFestivalLeave">
            No
          </v-btn>
          <v-btn color="#005f32" text @click="acceptFestivalLeave">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-center py-10>
      <v-flex xs12 sm11 md10 lg8>
        <v-card elevation="0" outlined class="rounded-lg overflow-hidden" style="background-color: #ffffff; border-color: #e0e0e0;">
          <!-- Header Section Minimal Design -->
          <div style="padding: 24px 30px; border-bottom: 1px solid #eeeeee;">
            <v-layout align-center>
              <v-flex>
                <h2 style="font-family: kumbhBold; font-size: 24px; color: #333; margin: 0; display: flex; align-items: center; gap: 10px;">
                  <v-icon color="#005f32">mdi-calendar-check-outline</v-icon> Apply for Leave
                </h2>
                <p style="font-family: kumbhRegular; font-size: 14px; color: #666; margin-top: 4px; margin-bottom: 0;">Submit your leave request by filling the details below</p>
              </v-flex>
            </v-layout>
          </div>

          <div style="padding: 30px;">
            <!-- Top Dashboard: Leaves Info and Action Buttons -->
            <v-layout wrap class="mb-8" align-center justify-space-between>
              <v-flex xs12 md6>
                <v-layout wrap>
                  <v-flex xs6 pa-1>
                    <v-card outlined class="rounded-lg text-center" style="background-color: #f0f7f3; border-color: #c3e6cb;">
                      <v-card-text class="pa-3">
                        <div style="font-size: 12px; color: #005f32; font-family: kumbhBold; text-transform: uppercase; letter-spacing: 0.5px;">Total Leaves</div>
                        <div style="font-size: 24px; color: #005f32; font-family: kumbhBold; margin-top: 5px;">{{ totalLeaves }}</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  
                  <v-flex xs6 pa-1>
                    <v-card outlined class="rounded-lg text-center" style="background-color: #fff4f4; border-color: #f5c6cb;">
                      <v-card-text class="pa-3">
                        <div style="font-size: 12px; color: #d9534f; font-family: kumbhBold; text-transform: uppercase; letter-spacing: 0.5px;">Leaves Taken</div>
                        <div style="font-size: 24px; color: #d9534f; font-family: kumbhBold; margin-top: 5px;">{{ leavesTaken }}</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 md6 text-md-right text-center class="pt-4 pt-md-0">
                <v-dialog v-model="dialogDetails" max-width="80%">
                  <v-card>
                    <v-layout wrap>
                      <v-flex xs12 align-self-center pa-4 style="background: #005f32" text-left>
                        <span class="kumbhBold" style="color: #ffffff">LEAVE DETAILS</span>
                      </v-flex>
                      <v-flex xs12 align-self-center class="kumbhBold">
                        <v-layout wrap pa-4>
                          <v-flex xs12 sm12 v-for="info in leaveCategories" :key="info._id">
                            <v-layout wrap>
                              <v-flex xs12 sm6 md3>
                                <v-layout wrap>
                                  <v-flex xs12>
                                    <span style="color: #005f32">Category</span>
                                  </v-flex>
                                  <v-flex xs12>
                                    <span>{{ info.leaveCategory }}</span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-layout wrap>
                                  <v-flex xs12>
                                    <span style="color: #005f32">Total Leaves</span>
                                  </v-flex>
                                  <v-flex xs12>
                                    <span>{{ info.totalLeaves }}</span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-layout wrap>
                                  <v-flex xs12>
                                    <span style="color: #005f32">Balance Leave</span>
                                  </v-flex>
                                  <v-flex xs12>
                                    <span>{{ info.totalLeaves - info.availedLeaves }}</span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-layout wrap>
                                  <v-flex xs12>
                                    <span style="color: #005f32">Leaves Taken</span>
                                  </v-flex>
                                  <v-flex xs12>
                                    <span>{{ info.availedLeaves }}</span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-dialog>
                <div class="d-flex flex-column align-center align-md-end h-100 justify-center">
                  <v-btn outlined color="#005f32" class="kumbhBold mb-3" style="background-color: white; border-width: 2px; width: 220px;" @click="dialogDetails = true">
                    <v-icon left small>mdi-information-outline</v-icon> Leave Details
                  </v-btn>

                <v-dialog v-model="dialogFestival" max-width="80%">
                  <v-card>
                    <v-layout wrap>
                      <v-flex xs12 align-self-center pa-4 style="background: #005f32" text-left>
                        <span class="kumbhBold" style="color: #ffffff">FESTIVAL LEAVES</span>
                      </v-flex>
                      <v-flex xs12 align-self-center pl-8 pt-4 text-left>
                        <div style="display: flex; align-items: center; gap: 16px; font-size: 16px;">
                          <!-- Green Dot for Office Open -->
                          <span style="display: flex; align-items: center;">
                            <span style="height: 10px; width: 10px; background-color: #28a745; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>
                            <span class="kumbhBold">Office Open</span>
                          </span>
                          <!-- Red Dot for Office Closed -->
                          <span style="display: flex; align-items: center;">
                            <span style="height: 10px; width: 10px; background-color: red; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>
                            <span class="kumbhBold">Office Closed</span>
                          </span>
                        </div>
                      </v-flex>
                      <v-flex xs12 pb-4 align-self-center class="kumbhBold">
                        <v-sheet height="64">
                          <v-toolbar flat>
                            <v-btn fab text small color="grey darken-2" @click="prev">
                              <v-icon small>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn fab text small color="grey darken-2" @click="next">
                              <v-icon small>mdi-chevron-right</v-icon>
                            </v-btn>
                            <v-toolbar-title>{{ monthYearTitle }}</v-toolbar-title>
                          </v-toolbar>
                        </v-sheet>
                        <v-sheet height="600">
                          <v-calendar ref="calendar" v-model="focus" color="success" :events="events" :type="type" @input="updateYear" />
                        </v-sheet>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-dialog>
                  <v-btn outlined color="#f57c00" class="kumbhBold" style="background-color: white; border-width: 2px; width: 220px;" @click="dialogFestival = true">
                    <v-icon left small>mdi-party-popper</v-icon> Festival Leaves
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>

            <v-divider class="mb-8"></v-divider>

            <!-- Application Form -->
            <v-layout wrap>
              <!-- Apply For Section -->
              <v-flex xs12 class="mb-5" v-if="userId && userId === '62a30b37d75aa11a84de313e'">
                <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Applying For</div>
                <v-radio-group v-model="appliedBy" row hide-details class="mt-0">
                  <v-radio label="Myself" value="me" color="#005f32"></v-radio>
                  <v-radio label="Employee" value="others" color="#005f32"></v-radio>
                </v-radio-group>
              </v-flex>

              <v-flex xs12 class="mb-5" v-if="appliedBy == 'others'">
                <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Select Employee</div>
                <v-autocomplete v-model="uid" :items="teamMembers" dense outlined :search-input.sync="search"
                  item-text="name" item-value="_id" prepend-inner-icon="mdi-account-search" placeholder="Search and select employee..." hide-details></v-autocomplete>
              </v-flex>

              <!-- Category and Type -->
              <v-flex xs12 sm6 class="pr-sm-3 mb-5">
                <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Leave Category</div>
                <v-select v-model="leaveCategory" :items="leaveCategories" item-text="leaveCategory"
                  item-value="leaveCategory" dense outlined prepend-inner-icon="mdi-tag-outline" hide-details></v-select>
              </v-flex>
              
              <v-flex xs12 sm6 class="pl-sm-3 mb-5">
                <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Leave Type</div>
                <v-select v-model="leaveType" :items="leaveTypes" item-text="name" item-value="value" dense
                  outlined prepend-inner-icon="mdi-clock-outline" hide-details></v-select>
              </v-flex>

              <!-- Dates Section -->
              <v-flex xs12 class="mb-5">
                <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Leave Dates</div>
                <v-card outlined class="pa-5 rounded-lg" style="background-color: #fafafa; border: 1px solid #e0e0e0;">
                  <v-layout wrap>
                    <v-flex xs12 sm6 class="pr-sm-3 mb-4 mb-sm-0">
                      <div style="font-family: kumbhRegular; font-size: 14px; color: #555; margin-bottom: 5px;">From Date</div>
                      <v-menu v-model="fromMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field outlined v-model="formattedFrom" prepend-inner-icon="mdi-calendar"
                            readonly v-bind="attrs" v-on="on" hide-details dense background-color="white"></v-text-field>
                        </template>
                        <v-date-picker v-model="fromDate" no-title scrollable @input="fromMenu = false" color="#005f32"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 class="pl-sm-3">
                      <div style="font-family: kumbhRegular; font-size: 14px; color: #555; margin-bottom: 5px;">To Date</div>
                      <v-menu v-model="toMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field outlined v-model="formattedTo" prepend-inner-icon="mdi-calendar"
                            readonly v-bind="attrs" v-on="on" hide-details dense background-color="white"></v-text-field>
                        </template>
                        <v-date-picker v-model="toDate" no-title scrollable @input="toMenu = false" color="#005f32"></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <!-- Selected Dates Chips -->
                  <div v-if="formattedDates && formattedDates.length > 0" class="mt-4">
                    <div style="font-size: 13px; color: #666; font-family: kumbhBold; margin-bottom: 5px;">Selected Regular Dates:</div>
                    <v-chip-group column>
                      <v-chip v-for="(item, index) in formattedDates" :key="index" small close @click:close="removeDate(index)" color="#e8f5e9" text-color="#005f32" class="font-weight-medium">
                        {{ item }}
                      </v-chip>
                    </v-chip-group>
                  </div>

                  <!-- Festival Leave Section -->
                  <div v-if="festivalDateArray && festivalDateArray.length > 0" class="mt-3">
                    <div style="font-size: 13px; color: #f57c00; font-family: kumbhBold; margin-bottom: 5px;">Festival Leaves Included:</div>
                    <v-chip-group column>
                      <v-chip v-for="(item, index) in formattedFestivalDates" :key="index" small close @click:close="removeFestivalDate(index)" color="#fff3e0" text-color="#e65100" class="font-weight-medium">
                        <v-icon left small>mdi-party-popper</v-icon> {{ item }}
                      </v-chip>
                    </v-chip-group>
                  </div>

                  <div class="mt-3 text-right" v-if="dateArray.length || (festivalDateArray && festivalDateArray.length)">
                    <v-btn text color="red" small @click="clearDates" class="kumbhBold" style="letter-spacing: 0.5px;">
                      <v-icon left small>mdi-delete-sweep</v-icon> Clear Dates
                    </v-btn>
                  </div>
                </v-card>
              </v-flex>

              <!-- Document Upload -->
              <v-flex xs12 class="mb-5">
                <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Supporting Document <span style="color: #999; font-size: 14px; font-weight: normal;">(Optional)</span></div>
                
                <v-sheet rounded="lg" class="pa-6 text-center" color="#f8f9fa"
                  style="border: 2px dashed #005f32; position: relative; transition: all 0.3s ease; cursor: pointer;"
                  @click="!docuploaded && $refs.fileInput.$refs.input.click()"
                  onmouseover="this.style.backgroundColor='#f0f7f3'"
                  onmouseout="this.style.backgroundColor='#f8f9fa'">
                  
                  <v-layout column align-center justify-center>
                    <v-icon size="48" color="#005f32" class="mb-3">mdi-cloud-upload-outline</v-icon>

                    <div v-if="!docuploaded">
                      <div style="color: #005f32; font-family: kumbhBold; font-size: 16px;">
                        Click to upload <span class="hidden-xs-only" style="color: #666; font-weight: normal;">or drag and drop</span>
                      </div>
                      <div class="caption grey--text mt-1" style="font-size: 13px;">Supported formats: PDF, DOC, DOCX</div>
                    </div>

                    <v-layout v-else align-center justify-center>
                      <v-chip color="#005f32" dark label close @click:close="clearFile($event)" class="px-4 py-2" style="height: auto; border-radius: 8px;">
                        <v-icon left>mdi-file-document-outline</v-icon>
                        <span class="text-wrap" style="max-width: 250px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;">{{ docuploaded.name }}</span>
                      </v-chip>
                    </v-layout>
                  </v-layout>

                  <v-file-input ref="fileInput" v-model="docuploaded" accept=".pdf,.doc,.docx" style="display: none;"
                    prepend-icon="" hide-details></v-file-input>
                </v-sheet>
                
                <v-messages :value="[fileValidation(docuploaded)]" color="error" class="mt-2"
                  v-if="docuploaded && fileValidation(docuploaded) !== true"></v-messages>
              </v-flex>

              <!-- Reason -->
              <v-flex xs12 class="mb-6">
                <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Reason for Leave</div>
                <v-textarea v-model="reason" outlined dense rows="4" placeholder="Please provide a brief reason for your leave request..." hide-details background-color="white" style="font-family: kumbhRegular;"></v-textarea>
              </v-flex>

              <!-- Submit Button -->
              <v-flex xs12>
                <v-btn block color="#005f32" dark x-large class="rounded-lg elevation-3" @click="validateInput()" style="font-family: kumbhBold; font-size: 18px; letter-spacing: 1px; text-transform: none;">
                  <v-icon left>mdi-send-check</v-icon> Submit Leave Request
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      festivalDates: [],
      holidays: [],
      holidayMap: {},
      dialogFestival: false,
      selectedYear: new Date().getFullYear(),
      visible: false,
      multi: true,
      showsnackbar: false,
      orgId: localStorage.getItem("orgid"),
      userId: localStorage.getItem("userid"),

      appliedBy: "me",
      isEditMode: false,
      editId: null,
      ignoreWatchers: false,
      uid: null,
      docuploaded: null,
      search: "",
      value: "",
      empID: "",
      fullName: "",
      email: "",
      phone: "",
      message: "",
      msg: "",
      leaveType: "Fullday",
      totalLeaves: null,
      leavesTaken: 0,
      leaveRequiredOn: "",
      leaveCategory: "",
      reason: "",
      leaveCategories: [],
      leaveTypes: [{ name: "Full Day", value: "Fullday" }, { name: "First Half", value: "FN" }, { name: "Second Half", value: "AN" }],
      isDateCorrect: true,

      teamMembers: [],
      focus: new Date().toISOString().substr(0, 10), // Set to current date

      dialogDetails: false,
      monthYearTitle: "",
      type: 'month', // Calendar view type
      dateArray: [],
      formattedDates: '',

      festivalDateArray: [],
      formattedFestivalDates: [],
      holidayMapByYear: {},
      festivalPromptQueue: [],
      currentFestivalPrompt: null,
      pendingFestivalPrompt: false,

      // New fields for From/To dates
      fromDate: null,
      toDate: null,
      fromMenu: false,
      toMenu: false,
      formattedFrom: '',
      formattedTo: ''
    };
  },
  computed: {
    events() {
      return this.holidays.map((festival) => ({
        start: festival.festivalDate.slice(0, 10),
        end: festival.festivalDate.slice(0, 10),
        name: `${festival.festivalName} (${festival.isOfficeOpen ? "Office Open" : "Office Closed"})`,
        color: festival.isOfficeOpen ? "#28a745" : "#d9534f", // Green for open, red for closed
      }));
    },
  },

  watch: {
    fromDate(val) {
      this.formattedFrom = val ? this.formatDate(val) : '';
      if (!this.ignoreWatchers) this.generateDates();
    },
    toDate(val) {
      this.formattedTo = val ? this.formatDate(val) : '';
      if (!this.ignoreWatchers) this.generateDates();
    },
    uid() {
      this.getleaves();
    },
    appliedBy() {
      if (this.appliedBy == "me") {
        this.uid = ""
      }
      if (this.appliedBy == "others") {
        this.leavesTaken = 0;
      }
      else { this.leavesTaken = 0; }
    },
    search(val) {
      this.loading = true;
      setTimeout(() => {
        this.getEmployeeList(val);
        this.loading = false;
      }, 500);
    },
    leaveCategory() {
      if (this.ignoreWatchers) return;
      this.clearDates();
      this.fromDate = null;
      this.toDate = null;
      this.formattedFrom = '';
      this.formattedTo = '';
    },
  },
  mounted() {
    this.getleaves();
    this.getEmployeeList();
    this.updateYear();
    if (this.$route.query.editId) {
      this.isEditMode = true;
      this.editId = this.$route.query.editId;
      this.fetchLeaveDataForEdit();
    }
  },
  methods: {
    fetchLeaveDataForEdit() {
      this.visible = true;
      axios({
        method: "POST",
        url: "/employee/leave/application/view/" + this.editId,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
      .then((response) => {
        this.visible = false;
        if (response.data.status === true) {
          this.ignoreWatchers = true;
          let data = response.data.data;
          this.reason = data.reason;
          this.leaveCategory = data.leaveCategory;
          this.leaveType = data.leaveType;
          
          let dates = data.leaveRequiredOn.map(d => new Date(d).toISOString().split('T')[0]);
          dates.sort();
          if (dates.length > 0) {
            this.fromDate = dates[0];
            this.toDate = dates[dates.length - 1];
            // format them
            this.formattedFrom = this.formatDate(this.fromDate);
            this.formattedTo = this.formatDate(this.toDate);
          }
          
          if (data.festivalRequiredOn && data.festivalRequiredOn.length > 0) {
            this.festivalDateArray = data.festivalRequiredOn.map(d => new Date(d).toISOString().split('T')[0]);
            this.formattedFestivalDates = this.festivalDateArray.map(date => this.formatDate(date));
          } else if (data.leaveCategory === 'Festival') {
            this.festivalDateArray = data.leaveRequiredOn.map(d => new Date(d).toISOString().split('T')[0]);
            this.formattedFestivalDates = this.festivalDateArray.map(date => this.formatDate(date));
          } else {
            this.festivalDateArray = [];
            this.formattedFestivalDates = [];
          }
          
          if (data.leaveCategory !== 'Festival') {
            let allDates = data.leaveRequiredOn.map(d => new Date(d).toISOString().split('T')[0]);
            this.dateArray = allDates.filter(d => !this.festivalDateArray.includes(d));
            this.formattedDates = this.dateArray.map(date => this.formatDate(date));
          }
          
          setTimeout(() => {
            this.ignoreWatchers = false;
          }, 200);
        }
      })
      .catch(() => {
        this.visible = false;
        this.msg = "Failed to load leave application data";
        this.showsnackbar = true;
      });
    },
    async generateDates() {
      if (this.fromDate && this.toDate) {
        let start = this.fromDate;
        let end = this.toDate;
        if (new Date(start) > new Date(end)) {
          [start, end] = [end, start];
        }

        // Ensure festival dates remain within the selected bounds
        let startDateObj = new Date(start);
        let endDateObj = new Date(end);
        
        this.festivalDateArray = this.festivalDateArray.filter(d => {
            let dObj = new Date(d);
            return dObj >= startDateObj && dObj <= endDateObj;
        });
        this.formattedFestivalDates = this.festivalDateArray.map(date => this.formatDate(date));

        this.dateArray = this.getDatesInRange(start, end);
        // Remove from dateArray any dates already in festivalDateArray
        this.dateArray = this.dateArray.filter(d => !this.festivalDateArray.includes(d));
        this.formattedDates = this.dateArray.map(date => this.formatDate(date));

        // Festival check logic
        if (this.leaveCategory === 'Casual') {
          await this.ensureHolidaysFetchedForYears(start, end);
          this.checkFestivals();
        }
      } else {
        this.dateArray = [];
        this.formattedDates = [];
      }
    },
    async ensureHolidaysFetchedForYears(start, end) {
      const startYear = new Date(start).getFullYear();
      const endYear = new Date(end).getFullYear();
      
      let yearsToFetch = [];
      if (!this.holidayMapByYear[startYear]) yearsToFetch.push(startYear);
      if (startYear !== endYear && !this.holidayMapByYear[endYear]) yearsToFetch.push(endYear);
      
      for (const y of yearsToFetch) {
        try {
          const res = await axios({
            method: "GET",
            url: "/festival/getalllist",
            headers: {
              "x-auth-token": localStorage.getItem("token"),
            },
            params: { year: y },
          });
          if (res.data.status) {
            this.$set(this.holidayMapByYear, y, res.data.data);
          }
        } catch(e) {
            console.error(e);
        }
      }
    },
    checkFestivals() {
      this.festivalPromptQueue = [];
      let allHolidays = [];
      for (let y in this.holidayMapByYear) {
         allHolidays = allHolidays.concat(this.holidayMapByYear[y]);
      }
      
      for (let dateStr of this.dateArray) {
         let match = allHolidays.find(h => {
             // ensure h.festivalDate is parsed safely to local YYYY-MM-DD to match dateStr
             return h.festivalDate.slice(0, 10) === dateStr; 
         });
         if (match) {
             this.festivalPromptQueue.push({ date: dateStr, festival: match });
         }
      }
      
      this.processFestivalQueue();
    },
    processFestivalQueue() {
       if (this.festivalPromptQueue.length > 0) {
          this.currentFestivalPrompt = this.festivalPromptQueue.shift();
          this.pendingFestivalPrompt = true;
       } else {
          this.pendingFestivalPrompt = false;
          this.currentFestivalPrompt = null;
       }
    },
    acceptFestivalLeave() {
       const dateStr = this.currentFestivalPrompt.date;
       this.dateArray = this.dateArray.filter(d => d !== dateStr);
       this.formattedDates = this.dateArray.map(date => this.formatDate(date));
       
       if (!this.festivalDateArray.includes(dateStr)) {
          this.festivalDateArray.push(dateStr);
          this.formattedFestivalDates = this.festivalDateArray.map(date => this.formatDate(date));
       }
       this.processFestivalQueue();
    },
    rejectFestivalLeave() {
       this.processFestivalQueue();
    },
    removeFestivalDate(index) {
       this.festivalDateArray.splice(index, 1);
       this.formattedFestivalDates = this.festivalDateArray.map(date => this.formatDate(date));
       this.generateDates();
    },
    getDatesInRange(start, end) {
      let dateArray = [];
      let currentDate = new Date(start);
      let stopDate = new Date(end);

      while (currentDate <= stopDate) {
        const dayOfWeek = currentDate.getDay();
        // 0 = Sunday, 6 = Saturday
        // Only push if it's NOT Sunday (0) and NOT Saturday (6)
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          dateArray.push(currentDate.toISOString().split("T")[0]);
        }

        // Move to next day
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dateArray;
    },
    removeDate(index) {
      // Remove the selected date from dateArray
      this.dateArray.splice(index, 1);

      // Update formattedDates to reflect the removal
      this.formattedDates = this.dateArray.map(date => this.formatDate(date));
    },
    // clearDates() {
    //   this.dateArray = [];
    //   this.formattedDates = [];
    // },
    clearDates() {
      this.dateArray = [];
      this.formattedDates = [];
      this.festivalDateArray = [];
      this.formattedFestivalDates = [];
      this.fromDate = null;
      this.toDate = null;
      this.formattedFrom = '';
      this.formattedTo = '';
    },
    clearFile(event) {
      if (event) event.stopPropagation();
      this.docuploaded = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
    },
    prev() {
      this.$refs.calendar.prev();
      this.updateYear();
    },
    // Move to the next period
    next() {
      this.$refs.calendar.next();
      this.updateYear();
    },
    fetchHolidays(year) {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/festival/getalllist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { year },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.holidays = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.error(err);
        });
    },
    updateYear() {
      const selectedDate = new Date(this.focus);
      const year = selectedDate.getFullYear();
      const month = selectedDate.toLocaleString("default", { month: "long" });
      this.monthYearTitle = `${month} ${year}`; // Update month and year title
      this.fetchHolidays(year); // Fetch holidays for the selected year
    },

    formatDate(date) {
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')  // Ensure two digits
      const month = String(d.getMonth() + 1).padStart(2, '0') // Months are zero-based
      const year = d.getFullYear()

      return `${day}-${month}-${year}` // Format as dd-mm-yyyy
    },
    // View day details when clicked

    createHolidayMap() {
      this.holidayMap = this.holidays.reduce((map, festivalDay) => {
        const dateStr = festivalDay.festivalDate.slice(0, 10); // Format as YYYY-MM-DD
        if (!map[dateStr]) {
          map[dateStr] = [];
        }
        map[dateStr].push(festivalDay);
        return map;
      }, {});
    },
    fileValidation(file) {
      if (!file) return true; // Optional: return true if no file is selected

      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ];

      const isCorrectType = allowedTypes.includes(file.type);
      return isCorrectType || 'Only PDF or Word documents are allowed';
    },
    validateInput() {
      const requestedDays = this.dateArray.length + (this.festivalDateArray ? this.festivalDateArray.length : 0);
      const availableDays = this.totalLeaves - this.leavesTaken;
      if (this.appliedBy == 'others') {
        if (!this.uid) {
          this.msg = "Please select an employee";
          this.showsnackbar = true;
          return;
        }
      }
      if (this.docuploaded && this.fileValidation(this.docuploaded) !== true) {
        this.msg = "Please upload a valid PDF or Word document";
        this.showsnackbar = true;
        return;
      }
      if (requestedDays > availableDays) {
        this.msg = `You only have ${availableDays} day(s) available, but you selected ${requestedDays} weekday(s).`;
        this.showsnackbar = true;
        return;
      }
      if (!this.dateArray.length > 0 && !(this.festivalDateArray && this.festivalDateArray.length > 0)) {
        this.msg = "Please select date";
        this.showsnackbar = true;
        return;
      } else if (!this.leaveType) {
        this.msg = "Please select leave type";
        this.showsnackbar = true;
        return;
      } else if (!this.leaveCategory) {
        this.msg = "Please select category";
        this.showsnackbar = true;
        return;
      }
      else if (!this.reason) {
        this.msg = "Please provide reason";
        this.showsnackbar = true;
        return;
      } else {
        // Everything is valid
        this.applyLeave();
      }
    },
    // validateInput() {

    //   if (this.appliedBy == 'others') {
    //     if (!this.uid) {
    //       // this.msg = "Please select team member";
    //       this.msg = "Please select an employee";
    //       this.showsnackbar = true;
    //       return;
    //     }
    //     else {
    //       this.applyLeave();
    //     }
    //   }
    //   else if (!this.dateArray.length > 0) {
    //     this.msg = "Please select date";
    //     this.showsnackbar = true;
    //     return;
    //   } else if (!this.leaveType) {
    //     this.msg = "Please select leave type";
    //     this.showsnackbar = true;
    //     return;
    //   } else if (!this.leaveCategory) {
    //     this.msg = "Please select category";
    //     this.showsnackbar = true;
    //     return;
    //   } else if (!this.reason) {
    //     this.msg = "Please provide reason";
    //     this.showsnackbar = true;
    //     return;
    //   } else {
    //     this.applyLeave();
    //   }
    // },
    getleaves() {
      this.visible = true;
      // var data1 = {};
      // data1["orgId"] = this.orgId;
      var id;
      if (this.appliedBy == "me") {
        id = this.userId;
        this.uid = "";
      }
      else if (this.appliedBy == "others") id = this.uid;

      axios({
        method: "POST",
        url: "/employee/leave/details/view/" + id,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.visible = false;
            this.leaveCategories = response.data.data.leaveDetails;
            this.leaveCategory = this.leaveCategories[0].leaveCategory;
            this.totalLeaves = response.data.totalAllowedLeaves;
            this.leavesTaken = response.data.totalAvailedLeaves;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((e) => {
          this.visible = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    getEmployeeList(val) {
      this.visible = true;
      axios({
        method: "GET",
        url: "/employee/attendance/mark/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // empId: this.userId,
          searchKeyword: val,
        },
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.visible = false;
            this.teamMembers = response.data.data;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((e) => {
          this.visible = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    async applyLeave() {
      this.visible = true; // Setting loading state
      let url = this.appliedBy === "me" ? "/employee/apply/leave/v1" : "/admin/apply/another/employee/leave";
      if (this.isEditMode) {
        url = "/employee/edit/leave/v1/" + this.editId;
      }
      
      let allSuccess = true;
      let errorMsg = "";

      if (!this.isDateCorrect) {
        this.visible = false;
        this.msg = `You can only select ${this.totalLeaves - this.leavesTaken} number of day(s)`;
        this.showsnackbar = true;
        return;
      }

      let allDates = [...this.dateArray];
      if (this.festivalDateArray && this.festivalDateArray.length > 0) {
        allDates = allDates.concat(this.festivalDateArray);
      }
      
      if (allDates.length > 0) {
        let formData = new FormData();
        let allDatesISO = allDates.map(date => new Date(date).toISOString());
        let festivalDateArrayISO = this.festivalDateArray ? this.festivalDateArray.map(date => new Date(date).toISOString()) : [];

        formData.append("reason", this.reason);
        formData.append("leaveType", this.leaveType);
        formData.append("leaveCategory", this.leaveCategory);
        formData.append("leaveRequiredOn", JSON.stringify(allDatesISO));
        formData.append("festivalRequiredOn", JSON.stringify(festivalDateArrayISO));

        if (this.appliedBy === "others") {
            formData.append("uid", this.uid);
        }
        if (this.docuploaded) {
            formData.append("docuploaded", this.docuploaded);
        }

        try {
            let response = await axios.post(url, formData, {
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                    "Content-Type": "multipart/form-data"
                }
            });
            if (!response.data.status) {
                allSuccess = false;
                errorMsg = response.data.msg || "Failed to submit leaves";
            }
        } catch(err) {
            allSuccess = false;
            errorMsg = err.response?.data?.msg || "An error occurred submitting leaves.";
        }
      }

      this.visible = false;
      if (allSuccess) {
         this.msg = "Leaves applied successfully";
         this.showsnackbar = true;
         this.$router.push({ name: "myLeaveList" });
      } else {
         this.msg = errorMsg;
         this.showsnackbar = true;
      }
    }
    // applyLeave() {
    //   let data1 = {};
    //   let dateArray = this.dateArray.map(date => new Date(date).toISOString()); // Always use the final dateArray (expanded and pruned)

    //   data1["reason"] = this.reason;
    //   data1["leaveType"] = this.leaveType;
    //   data1["leaveCategory"] = this.leaveCategory;
    //   data1["leaveRequiredOn"] = dateArray;

    //   if (this.appliedBy === "others") {
    //     data1["uid"] = this.uid;
    //   }

    //   let url = this.appliedBy === "me" ? "/employee/apply/leave/v1" : "/admin/apply/another/employee/leave";

    //   if (this.isDateCorrect) {
    //     axios.post(url, data1, { headers: { "x-auth-token": localStorage.getItem("token") } })
    //       .then(response => {
    //         this.visible = false;
    //         this.status = response.data.status;
    //         this.msg = response.data.msg;
    //         this.showsnackbar = true;
    //         if (response.data.status) this.$router.push({ name: "myLeaves" });
    //       })
    //       .catch(err => {
    //         this.visible = false;
    //         this.msg = err.response?.data?.status === false ? "Please Try Again" : "An error occurred.";
    //         this.showsnackbar = true;
    //       });
    //   } else {
    //     this.msg = `You can only select ${this.totalLeaves - this.leavesTaken} number of day(s)`;
    //     this.showsnackbar = true;
    //   }
    // }
  },
};
</script>